export const titles = [
  { name: 'Introduction', id: 'introduction' },
  { name: 'LSE AI-Fellowship', id: 'journalism-ai' },
  { name: 'Initial Ideas', id: 'initial-ideas' },
  { name: 'User Research', id: 'user-research' },
  { name: 'Final Product', id: 'final-concept' },
  { name: 'Technical Description', id: 'technical-description' },
  { name: 'Critical discussion', id: 'critical-discussion' },
  { name: 'Learnings', id: 'learnings' },
  { name: 'About', id: 'about' },
];
